import React from "react";
export default function MobileBoardHeader({selectedDayMs}) {
  return <p className="schedule-mobile-heading">{new Date(selectedDayMs).toLocaleDateString(undefined,{weekday:'long',month:'short',day:'numeric'})} · Shifts by role</p>;
}
